<section class="validation-error-panel">
  <!-- GEN-E-52-11: classic mode keeps the original static gradient sparkle icon on the "Ask XatBot"
       button below; ITP 2.0 gets the glowing AiTaxIcon mark instead. This def is only consumed by
       classic mode's <svg fill="url(#validation-error-xatbot-sparkle)"> further down. -->
  <svg width="0" height="0" aria-hidden="true" focusable="false" style="position: absolute;">
    <defs>
      <linearGradient id="validation-error-xatbot-sparkle" x1="1.0625" y1="2.39063" x2="15.9375" y2="16.2031"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F7AE42" />
        <stop offset="0.555826" stop-color="#E82A7F" />
        <stop offset="1" stop-color="#B9299E" />
      </linearGradient>
    </defs>
  </svg>
  <mat-tab-group class="validation-error-tabs blue-line-minimal-tabs sidebar-tabs" animationDuration="0ms"
    [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabIndexChange($event)">
    <mat-tab label="XML Validation" *ngIf="homeSideBarItem.fieldValues['IsValidationRuleAvailable'] !== false">
      <ng-template mat-tab-label><span data-cy="validation-tab-xml">XML Validation</span></ng-template>
      <ng-container *ngTemplateOutlet="errorPanel"></ng-container>
    </mat-tab>

    <mat-tab label="Additional Validation" *ngIf="homeSideBarItem.fieldValues['IsBusinessRuleAvailable'] === true">
      <ng-template mat-tab-label><span data-cy="validation-tab-additional">Additional Validation</span></ng-template>
      <ng-container *ngTemplateOutlet="errorPanel"></ng-container>
    </mat-tab>

    <mat-tab label="All Rules" *ngIf="isAllRulesAvailable">
      <ng-template mat-tab-label><span data-cy="validation-tab-all-rules">All Rules</span></ng-template>
      <ng-container *ngTemplateOutlet="allRulesPanel"></ng-container>
    </mat-tab>
  </mat-tab-group>
</section>

<ng-template #allRulesPanel>
  <div class="all-rules-tab-body">
    <div class="all-rules-toolbar">
      <div class="all-rules-search search-container">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <span matIconPrefix class="search-icon"><i class="far fa-search"></i></span>
          <input matInput type="search" placeholder="Search rule id, path, or source" [value]="allRulesSearchTerm"
            (input)="onAllRulesSearchInput($event)" />
        </mat-form-field>
      </div>

      <div class="all-rules-metric-bar error-type-metric-bar" role="group" aria-label="Filter by severity">
        <button type="button" role="checkbox" *ngFor="let bucket of allRulesBuckets"
          class="metric-card all-rules-metric-card" [attr.aria-checked]="allRulesSelectedBuckets.includes(bucket)"
          [class.metric-card--file]="bucket === 'file' && allRulesSelectedBuckets.includes(bucket)"
          [class.metric-card--severe]="bucket === 'severe' && allRulesSelectedBuckets.includes(bucket)"
          [class.metric-card--other]="bucket === 'other' && allRulesSelectedBuckets.includes(bucket)"
          (click)="toggleAllRulesBucket(bucket)">
          <span class="metric-bar__label">{{ allRulesBucketLabel(bucket) }}</span>
        </button>
      </div>
    </div>

    <ng-container *ngIf="!isAllRulesLoading; else allRulesLoading">
      <div *ngIf="filteredAllRulesEntries.length === 0" class="all-rules-empty">
        <ng-container *ngIf="allRulesEntries.length === 0; else noMatches">
          Rules catalog not available for this entry.
        </ng-container>
        <ng-template #noMatches>No rules match the current filters.</ng-template>
      </div>

      <mat-accordion class="all-rules-accordion" [multi]="true" *ngIf="filteredAllRulesEntries.length > 0">
        <mat-expansion-panel *ngFor="let entry of filteredAllRulesEntries; trackBy: trackByRuleId"
          class="all-rules-panel" togglePosition="before" [class.all-rules-panel--file]="entry.bucket === 'file'"
          [class.all-rules-panel--severe]="entry.bucket === 'severe'"
          [class.all-rules-panel--other]="entry.bucket === 'other'" (opened)="onAllRulesPanelOpened(entry.ruleId)"
          (closed)="onAllRulesPanelClosed(entry.ruleId)">
          <mat-expansion-panel-header [collapsedHeight]="'44px'" [expandedHeight]="'44px'">
            <mat-panel-title class="all-rules-panel__title" [matTooltip]="allRulesTooltip(entry)">
              <span class="all-rules-tick" [attr.data-bucket]="entry.bucket"></span>
              <span class="all-rules-rule-id">{{ entry.ruleId }}</span>
              <span class="all-rules-sev-pill" [attr.data-bucket]="entry.bucket">{{ allRulesBucketLabel(entry.bucket)
                }}</span>
              <span class="all-rules-count">
                <b>{{ entry.pathCount }}</b> {{ entry.pathCount === 1 ? 'path' : 'paths' }}
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="all-rules-paths">
            <div class="all-rules-paths-rail" aria-hidden="true"></div>
            <div *ngFor="let p of pathsForEntry(entry)" class="all-rules-path" [class.navigable]="p.isNavigable"
              [class.inert]="!p.isNavigable" (click)="onAllRulesPathClick(p, $event)">
              <span class="path-loc" [class.unknown]="!p.sourceRef" [title]="p.sourceRef || 'unknown'">{{ p.sourceRef ||
                'unknown' }}</span>
              <span class="path-trace" [title]="p.path">{{ p.path }}</span>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

    <ng-template #allRulesLoading>
      <div class="all-rules-loading">Loading rules...</div>
    </ng-template>
  </div>
</ng-template>

<ng-template #errorPanel>
  <header class="validation-error-header">
    <div class="validation-error-actions" *ngIf="!(hasValidationErrors && activeTab === 'business')">
      <button mat-raised-button type="button" [disabled]="isLoading" (click)="refresh()" class="regenerate-btn"
        data-cy="validation-regenerate-btn">
        <mat-icon [class.spin]="isLoading">refresh</mat-icon>
        <span *ngIf="!isLoading && !hasGenerated">Generate</span>
        <span *ngIf="!isLoading && hasGenerated">Regenerate</span>
        <span *ngIf="isLoading && !hasGenerated">Generating...</span>
        <span *ngIf="isLoading && hasGenerated">Regenerating...</span>
      </button>
      <button mat-raised-button type="button" [disabled]="isLoading || isDownloading"
        (click)="downloadXmlAndValidationErrors()" class="regenerate-btn download-btn"
        [class.is-downloading]="isDownloading"
        data-cy="validation-download-btn">
        <span class="download-icon-wrap">
          <mat-icon class="download-icon-base">download</mat-icon>
          <mat-icon class="download-icon-arrow">arrow_downward</mat-icon>
        </span>
        <span>{{ isDownloading ? 'Downloading...' : 'Download' }}</span>
      </button>
    </div>

    <span *ngIf="false" class="tolerance-percent-toggle-wrap">
      <mat-slide-toggle class="tolerance-percent-toggle" [disabled]="isLoading" [checked]="tolerancePercentEnabled"
        (change)="tolerancePercentEnabled = $event.checked">
        1% tolerance
      </mat-slide-toggle>
      <span class="tolerance-percent-toggle__info" (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()">
        <particle-dynamic-tooltip-container [text]="toleranceToggleTooltip" [position]="'bottom'" [theme]="'dark'"
          [cssClass]="'elite-form-validation-tooltip-content'" [width]="340">
          <i class="fa-regular fa-circle-info" aria-label="1% tolerance toggle info"></i>
        </particle-dynamic-tooltip-container>
      </span>
    </span>
  </header>

  <div class="validation-error-metrics" *ngIf="activeTab === 'business' && hasValidationErrors">
    <div class="error-type-metric-bar" role="group" aria-label="Filter by error category">
      <button type="button" role="checkbox" class="metric-card" *ngFor="let cat of metricCategories"
        [attr.aria-checked]="isOecdBucketSelected(cat.bucket)"
        [class.metric-card--file]="cat.bucket === 'file' && isOecdBucketSelected(cat.bucket)"
        [class.metric-card--severe]="cat.bucket === 'severe' && isOecdBucketSelected(cat.bucket)"
        [class.metric-card--other]="cat.bucket === 'other' && isOecdBucketSelected(cat.bucket)"
        (click)="toggleOecdBucket(cat.bucket)">
        <span class="metric-bar__count">{{ oecdMetricCounts[cat.bucket] }}</span>
        <span class="metric-bar__label">
          <span class="metric-bar__label--long">{{ cat.metricLabel }}</span>
          <span class="metric-bar__label--short">{{ cat.metricLabel }}</span>
          <span class="metric-card-info" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
            <particle-dynamic-tooltip-container [text]="oecdMetricTooltipPlainText(cat)" [position]="'bottom'"
              [theme]="'dark'" [cssClass]="'elite-form-validation-tooltip-content'" [width]="315">
              <i class="fa-regular fa-circle-info" [attr.aria-label]="oecdTooltipTitle(cat)"></i>
            </particle-dynamic-tooltip-container>
          </span>
        </span>
      </button>
    </div>
  </div>

  <div class="validation-error-status validation-error-status--info" *ngIf="isInitialLoading">
    <div class="validation-error-status-icon-wrap">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    <p class="validation-error-status-title">Loading saved results...</p>
    <p class="validation-error-status-sub">
      Fetching the last validation run for this form.
    </p>
  </div>

  <div class="validation-error-status validation-error-status--info" *ngIf="isReadyToValidate">
    <div class="validation-error-status-icon-wrap">
      <mat-icon class="validation-error-status-icon">fact_check</mat-icon>
    </div>
    <p class="validation-error-status-title">Validate this form</p>
    <p class="validation-error-status-sub">
      Click <strong>Generate</strong> to check this form against all schema rules before submitting.
    </p>
  </div>

  <div class="validation-error-status validation-error-status--warning" *ngIf="hasMappingIssue">
    <div class="validation-error-status-icon-wrap">
      <!--      <mat-icon class="validation-error-status-icon">report_problem</mat-icon>-->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.44 43.75">
        <defs>
          <style>
            .cls-1 {
              fill: #ced7db;
            }

            .cls-2 {
              fill: #ebeef0;
            }

            .cls-3 {
              fill: #8a97a5;
            }

            .cls-4 {
              fill: #5485e4;
            }

            .cls-5 {
              fill: #5e93fe;
            }

            .cls-6 {
              fill: #5e94fe;
            }
          </style>
        </defs>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path class="cls-1"
              d="M17.73,43.74H5.94A5.81,5.81,0,0,1,0,37.84c.11-10.67.08-21.35,0-32A5.72,5.72,0,0,1,5.84,0c4,0,7.93,0,11.89,0a2,2,0,0,1,.33,1.53c-.07,4,0,8,0,12a22.84,22.84,0,0,0,.12,2.74c0,.2-.2.28-.37.34-1,.38-1.27.65-1.28,1.72,0,3.07,0,6.14,0,9.21a2,2,0,0,0,1.22,1.87c.44.66.27,1.45.44,2.16a.64.64,0,0,1-.38.26,1.41,1.41,0,0,0-1.3,1.57c0,.73,0,1.46,0,2.18a1.69,1.69,0,0,0,1,1.77,1.12,1.12,0,0,1,.45.49A34.09,34.09,0,0,1,18,43.06,1,1,0,0,1,17.73,43.74Z" />
            <path class="cls-2"
              d="M17.73,43.74V37.66c1.82-1.27,1.21-3.13,1.17-4.84,0-.54-.61-.8-.79-1.27-.69-.58-.27-1.36-.37-2a1.09,1.09,0,0,0,.08-.15A2.26,2.26,0,0,0,19,27.07c-.05-2.52,0-5,0-7.56a4.25,4.25,0,0,0-.86-3.18c-.48-.28-.38-.75-.38-1.18q0-7.56,0-15.14a5.36,5.36,0,0,1,4,1.36c-.31.29-.71.22-1.08.26a2.06,2.06,0,0,0-2,2.1c-.05,2.15-.07,4.31,0,6.46a5,5,0,0,0,4.84,4.72c2.54.05,5.07,0,7.61,0a2.16,2.16,0,0,0,2.35-2.46c0-.34-.14-.7.06-1a4.4,4.4,0,0,1,1.93,3.62c.05,7.83,0,15.65,0,23.48a5.46,5.46,0,0,1-3.69,4.83,7,7,0,0,1-2.32.39C25.52,43.73,21.63,43.74,17.73,43.74Z" />
            <path class="cls-3"
              d="M33.48,11.43a2.65,2.65,0,0,1-2.72,3.85c-2.31-.15-4.63,0-6.94,0a5.41,5.41,0,0,1-5.53-5.52c0-1.75.1-3.5,0-5.23-.17-2.31,1.32-3.57,3.46-3.12C24.06,3.11,26.19,5.11,28.41,7,30.12,8.44,31.89,9.84,33.48,11.43Z" />
            <path class="cls-4"
              d="M17.75,29.51c-1.17-.26-1.53-.67-1.53-1.78,0-3.22,0-6.43,0-9.65,0-1.15.44-1.63,1.52-1.72a1.7,1.7,0,0,1,.32,1.25c0,3.53,0,7.07,0,10.6a1.61,1.61,0,0,1-.33,1.25Z" />
            <path class="cls-5"
              d="M17.73,29.46q0-6.55,0-13.1l.38,0a1.67,1.67,0,0,1,1.15,1.77c0,3.2,0,6.4,0,9.6C19.26,28.85,18.86,29.28,17.73,29.46Z" />
            <path class="cls-6"
              d="M18.12,31.55a1.62,1.62,0,0,1,1.15,1.73c0,.76,0,1.51,0,2.26,0,1.33-.26,1.69-1.52,2.12l-.4-.17c.15-1.52.06-3,.09-4.56a1.85,1.85,0,0,1,.31-1.35Z" />
            <path class="cls-4"
              d="M17.74,31.58v5.09c0,.33.1.73-.4.82A1.39,1.39,0,0,1,16.22,36c0-1,0-1.9,0-2.85A1.42,1.42,0,0,1,17.74,31.58Z" />
          </g>
        </g>
      </svg>
    </div>
    <p class="validation-error-status-title">We ran into a problem validating this form</p>
    <p class="validation-error-status-sub" *ngIf="!mappingTicketDisplayId">
      Something unexpected happened while reading your workbook data. This is usually caused by an issue importing data
      from the GMT Calculator.
      <br />
      If the problem persists, please contact our support team.
    </p>
    <p class="validation-error-status-sub" *ngIf="mappingTicketDisplayId">
      Something unexpected happened while reading your workbook data. This is usually caused by an issue importing data
      from the GMT Calculator.
      <br />
      Your support ticket has been created — a member of our team will follow up with you shortly.
    </p>

    <div class="validation-error-ticket-block" *ngIf="mappingTicketDisplayId">
      <div class="validation-error-ticket">
        <span class="validation-error-ticket-label">Support ticket</span>
        <a class="validation-error-ticket-link" *ngIf="mappingTicketUrl; else ticketIdOnly" [href]="mappingTicketUrl"
          target="_blank" rel="noopener">
          {{ mappingTicketDisplayId }}
          <mat-icon class="validation-error-ticket-icon">open_in_new</mat-icon>
        </a>
        <ng-template #ticketIdOnly>
          <span class="validation-error-ticket-id">{{ mappingTicketDisplayId }}</span>
        </ng-template>
      </div>
    </div>

    <div class="validation-error-ticket-block" *ngIf="!mappingTicketDisplayId">
      <button mat-button color="primary" type="button" class="validation-error-create-ticket-btn action-button"
        (click)="openCreateSupportTicketDialog()">
        <span>Open a Support Ticket</span>
      </button>
    </div>
  </div>

  <div class="validation-error-rule-filter"
    *ngIf="hasValidationErrors && activeTab === 'business'">
    <div class="rule-filter-field-wrap" *ngIf="codesForDropdown.length > 0">
      <mat-form-field appearance="outline" class="rule-filter-field" subscriptSizing="dynamic">
        <mat-label>Filter by error code</mat-label>
        <mat-select multiple [value]="selectedRuleIds" (selectionChange)="onBusinessCodesFilterChange($event.value)"
          panelClass="rule-filter-panel" (openedChange)="onBusinessCodeFilterOpenedChange($event)">
          <mat-select-trigger>
            <span>{{ businessCodesFilterTriggerLabel }}</span>
          </mat-select-trigger>
          <div class="rule-filter-search" (click)="$event.stopPropagation()">
            <i class="far fa-search rule-filter-search__icon" aria-hidden="true"></i>
            <input #ruleFilterSearchInput type="text" class="rule-filter-search__input" autocomplete="off"
              placeholder="Search code or message" [value]="businessCodeFilterSearch"
              (input)="onBusinessCodeFilterSearchInput($event)" (keydown)="$event.stopPropagation()" />
            <button type="button" class="rule-filter-search__clear" *ngIf="businessCodeFilterSearch"
              (click)="clearBusinessCodeFilterSearch($event)" aria-label="Clear search">
              <i class="fa-regular fa-xmark"></i>
            </button>
          </div>
          <mat-option *ngIf="hasAnyNotedErrors && notesRowMatchesSearch" [value]="notesFilterId"
            class="rule-filter-option--notes">
            <span class="rule-filter-option rule-filter-option--notes-row">
              <i class="fa-solid fa-circle-info m-r-4 rule-filter-option-notes-icon" aria-hidden="true"></i>
              <span class="rule-filter-option-id">Priority details ({{ notesFilterCount }})</span>
            </span>
          </mat-option>
          <mat-option *ngFor="let rule of filteredCodesForDropdown" [value]="rule.ruleId">
            <span class="rule-filter-option"
              [title]="rule.ruleId + (rule.validationMessage ? ' — ' + rule.validationMessage : '')">
              <span *ngIf="rule.countryCode" class="fflag ff-md m-r-4" [ngClass]="'fflag-' + rule.countryCode"></span>
              <span class="rule-filter-option-id">{{ displayRuleCode(rule.ruleId) }}</span>
              <ng-container *ngFor="let pair of getPairsForRule(rule.ruleId)">
                <span *ngIf="pair.countryCode" class="fflag ff-md m-l-4 m-r-2"
                  [ngClass]="'fflag-' + pair.countryCode"></span>
                <span class="rule-filter-option-pair-id">{{ displayRuleCode(pair.ruleId) }}</span>
              </ng-container>
              <span class="rule-filter-option-msg" *ngIf="rule.validationMessage">
                — {{ rule.validationMessage }}
              </span>
            </span>
          </mat-option>
          <div class="rule-filter-no-results"
            *ngIf="businessCodeFilterSearch && filteredCodesForDropdown.length === 0 && !notesRowMatchesSearch">
            No codes match "{{ businessCodeFilterSearch }}"
          </div>
        </mat-select>
      </mat-form-field>
      <button mat-button type="button" class="rule-filter-clear" *ngIf="selectedRuleIds.length > 0"
        (click)="clearBusinessCodeFilters()">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <button type="button"
            [disabled]="isLoading"
            (click)="refresh()"
            class="filter-action-icon-btn"
            matTooltip="Regenerate"
            matTooltipPosition="above"
            data-cy="validation-regenerate-icon-btn">
      <i class="fa-regular fa-arrows-rotate" [class.spin]="isLoading"></i>
    </button>
    <button type="button"
            [disabled]="isLoading || isDownloading"
            (click)="downloadXmlAndValidationErrors()"
            class="filter-action-icon-btn"
            [class.is-downloading]="isDownloading"
            matTooltip="Download"
            matTooltipPosition="above"
            data-cy="validation-download-icon-btn">
      <span class="filter-download-icon-wrap">
        <i class="fa-solid fa-download filter-download-icon-base"></i>
        <i class="fa-solid fa-arrow-down filter-download-icon-arrow"></i>
      </span>
    </button>
  </div>

  <div class="hide-unenforced-toggle-row" *ngIf="hasValidationErrors && activeTab === 'business' && !isBundleBusinessRules">
    <span class="hide-unenforced-toggle__label-block">
      <span class="hide-unenforced-toggle__label">Hide unenforced errors</span>
      <span class="hide-unenforced-toggle__info" (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()">
        <particle-dynamic-tooltip-container [text]="hideUnenforcedToggleTooltip" [position]="'bottom'" [theme]="'dark'"
          [cssClass]="'elite-form-validation-tooltip-content'" [width]="340">
          <i class="fa-regular fa-circle-info" aria-label="Hide unenforced errors info"></i>
        </particle-dynamic-tooltip-container>
      </span>
    </span>
    <mat-slide-toggle class="hide-unenforced-toggle" [disabled]="isLoading" [checked]="hideUnenforced"
      (change)="hideUnenforced = $event.checked"></mat-slide-toggle>
  </div>

  <!-- <div class="validation-error-stale-banner"
       *ngIf="isStale && hasValidationErrors && activeTab === 'business' && selectedOecdBuckets.length > 0">
    <mat-icon class="validation-error-stale-banner__icon">info</mat-icon>
    <span class="validation-error-stale-banner__text">
      The form has changed since these errors were generated.
      Click <strong>Regenerate</strong> to refresh.
    </span>
  </div> -->

  <mat-accordion class="validation-error-bucket-accordion" [multi]="false"
    *ngIf="hasValidationErrors && activeTab === 'business' && selectedOecdBuckets.length > 0">
    <ng-container *ngFor="let cat of oecdCategories">
      <mat-expansion-panel *ngIf="isOecdBucketSelected(cat.bucket)" [expanded]="cat.bucket === expandedBucketAccordion"
        (opened)="onBucketAccordionOpened(cat.bucket)" (closed)="onBucketAccordionClosed(cat.bucket)"
        class="validation-error-bucket-panel" [class.validation-error-bucket-panel--file]="cat.bucket === 'file'"
        [class.validation-error-bucket-panel--severe]="cat.bucket === 'severe'"
        [class.validation-error-bucket-panel--other]="cat.bucket === 'other'">
        <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'">
          <mat-panel-title class="validation-error-bucket-panel__title">
            {{ cat.metricLabel }} ({{ oecdMetricCounts[cat.bucket] }})
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="validation-error-table-wrapper">
          <table class="validation-error-table">
            <thead>
              <tr>
                <th class="col-id">ID</th>
                <th class="col-message">Error Message</th>
                <!-- <th class="col-xatbot" aria-label="Ask XatBot" *ngIf="!isQatarCluster"></th> -->
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="businessGroupedRowsForBucket(cat.bucket).length === 0">
                <tr *ngFor="let error of businessFlatDisplayErrorsForBucket(cat.bucket); trackBy: trackByError"
                  (click)="selectRow(error)" class="validation-error-row-clickable"
                  [class.error-row--unenforced]="error.isUnenforced"
                  [class.validation-error-row--selected]="isRowSelected(error)">
                  <td class="col-id">{{ error.errorSequenceId }}</td>
                  <td class="col-message">
                    <ng-container *ngTemplateOutlet="msgBody1"></ng-container>
                    <ng-template #msgBody1>
                      <span class="validation-error-msg-flow">
                        <span class="validation-error-code-line" *ngIf="effectiveRuleIdForError(error) as rid">
                          <span *ngIf="errorCodeBadgeBucket(error) as bb" [ngClass]="badgeClassForBucket(bb)">{{
                            displayBadgeLabel(rid) }}</span>
                          <span *ngIf="errorCodeBadgeBucket(error) === null"
                            class="error-code-badge error-code-badge--plain">{{ displayBadgeLabel(rid) }}</span>
                          <span *ngFor="let cid of error.countryRuleIds || []"
                            class="error-code-badge error-code-badge--country">{{ displayBadgeLabel(cid) }}</span>
                          <ng-container *ngTemplateOutlet="validationNotesPill; context: { rid: rid }"></ng-container>
                        </span>
                        <ng-container *ngTemplateOutlet="errorMessageCell; context: { error: error }"></ng-container>
                      </span>
                    </ng-template>
                    <ng-container *ngTemplateOutlet="errorRowActions; context: { err: error }"></ng-container>
                  </td>
                </tr>
                <tr *ngIf="businessFlatDisplayErrorsForBucket(cat.bucket).length === 0"
                  class="validation-error-row-empty">
                  <td [attr.colspan]="isQatarCluster ? 2 : 3" class="validation-error-row-empty-cell">
                    No errors match the current filters.
                  </td>
                </tr>
              </ng-container>

              <ng-container
                *ngFor="let group of businessGroupedRowsForBucket(cat.bucket); trackBy: trackByBusinessGroup">
                <tr *ngIf="group.instances.length === 1" (click)="selectRow(group.instances[0])"
                  class="validation-error-row-clickable" [class.error-row--unenforced]="group.instances[0].isUnenforced"
                  [class.validation-error-row--selected]="isRowSelected(group.instances[0])">
                  <td class="col-id">{{ group.instances[0].errorSequenceId }}</td>
                  <td class="col-message">
                    <ng-container *ngTemplateOutlet="msgBody2"></ng-container>
                    <ng-template #msgBody2>
                      <span class="validation-error-msg-flow">

                        <span class="validation-error-code-line"
                          *ngIf="effectiveRuleIdForError(group.instances[0]) as rid">
                          <span *ngIf="errorCodeBadgeBucket(group.instances[0]) as bb"
                            [ngClass]="badgeClassForBucket(bb)">{{ displayBadgeLabel(rid) }}</span>
                          <span *ngIf="errorCodeBadgeBucket(group.instances[0]) === null"
                            class="error-code-badge error-code-badge--plain">{{ displayBadgeLabel(rid) }}</span>
                          <span *ngFor="let cid of group.instances[0].countryRuleIds || []"
                            class="error-code-badge error-code-badge--country">{{ displayBadgeLabel(cid) }}</span>
                          <ng-container *ngTemplateOutlet="validationNotesPill; context: { rid: rid }"></ng-container>
                        </span>
                        <ng-container
                          *ngTemplateOutlet="errorMessageCell; context: { error: group.instances[0] }"></ng-container>
                      </span>
                    </ng-template>
                    <ng-container *ngTemplateOutlet="errorRowActions; context: { err: group.instances[0] }"></ng-container>
                  </td>
                </tr>

                <ng-container *ngIf="group.instances.length > 1">
                  <tr class="validation-error-row-group-parent"
                    [class.error-row--unenforced]="group.instances[0].isUnenforced">
                    <td class="col-id">{{ group.groupIndex }}</td>
                    <td class="col-message">
                      <particle-dynamic-tooltip-container *ngIf="group.instances[0].tooltipMessage; else msgBody3"
                        [text]="group.instances[0].tooltipMessage || ''" [position]="'top'" [theme]="'dark'"
                        [cssClass]="'elite-form-validation-tooltip-content'" [width]="300">
                        <ng-container *ngTemplateOutlet="msgBody3"></ng-container>
                      </particle-dynamic-tooltip-container>
                      <ng-template #msgBody3>
                        <span class="validation-error-msg-flow">
                          <span [ngClass]="badgeClassForBucket(group.bucket)">{{ displayBadgeLabel(group.ruleId)
                            }}</span>
                          <span *ngFor="let cid of group.instances[0].countryRuleIds || []"
                            class="error-code-badge error-code-badge--country">{{ displayBadgeLabel(cid) }}</span>
                          <ng-container
                            *ngTemplateOutlet="validationNotesPill; context: { rid: group.ruleId }"></ng-container>
                          <span class="validation-error-group-summary">{{ group.summaryMessage }}</span>
                        </span>
                      </ng-template>
                    </td>
                  </tr>
                  <tr [class.error-row--unenforced]="group.instances[0].isUnenforced">
                    <td colspan="3" class="p-lr-0 p-tb-0">
                      <div class="validation-group-instance" (click)="toggleGroupExpanded(group, $event)">
                        <span class="validation-error-group-count">{{ group.instances.length }} instances</span>
                        <button type="button" class="validation-error-group-toggle"
                          [attr.aria-expanded]="isBusinessGroupExpanded(group.ruleId)">
                          <mat-icon>{{ isBusinessGroupExpanded(group.ruleId) ? 'expand_less' : 'expand_more'
                            }}</mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <ng-container *ngFor="let err of group.instances; let i = index">
                    <tr *ngIf="isBusinessGroupExpanded(group.ruleId)" (click)="selectRow(err)"
                      class="validation-error-row-clickable validation-error-row-group-child"
                      [class.error-row--unenforced]="err.isUnenforced"
                      [class.validation-error-row--selected]="isRowSelected(err)">
                      <td class="col-id">{{ group.groupIndex }}.{{ i + 1 }}</td>
                      <td class="col-message">
                        <ng-container *ngTemplateOutlet="msgBody4"></ng-container>
                        <ng-template #msgBody4>
                          <span class="validation-error-msg-flow">

                            <span class="validation-error-code-line" *ngIf="effectiveRuleIdForError(err) as rid">
                              <span *ngIf="errorCodeBadgeBucket(err) as bb" [ngClass]="badgeClassForBucket(bb)">{{
                                displayBadgeLabel(rid) }}</span>
                              <span *ngIf="errorCodeBadgeBucket(err) === null"
                                class="error-code-badge error-code-badge--plain">{{ displayBadgeLabel(rid) }}</span>
                              <span *ngFor="let cid of err.countryRuleIds || []"
                                class="error-code-badge error-code-badge--country">{{ displayBadgeLabel(cid) }}</span>
                              <ng-container
                                *ngTemplateOutlet="validationNotesPill; context: { rid: rid }"></ng-container>
                            </span>
                            <ng-container *ngTemplateOutlet="errorMessageCell; context: { error: err }"></ng-container>
                          </span>
                        </ng-template>
                        <ng-container *ngTemplateOutlet="errorRowActions; context: { err: err }"></ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>

  <!-- <div class="validation-error-stale-banner"
       *ngIf="isStale && hasValidationErrors && (activeTab !== 'business' || selectedOecdBuckets.length === 0)">
    <mat-icon class="validation-error-stale-banner__icon">info</mat-icon>
    <span class="validation-error-stale-banner__text">
      The form has changed since these errors were generated.
      Click <strong>Regenerate</strong> to refresh.
    </span>
  </div> -->

  <div class="validation-error-table-wrapper"
    *ngIf="hasValidationErrors && (activeTab !== 'business' || selectedOecdBuckets.length === 0)">
    <table class="validation-error-table">
      <thead>
        <tr>
          <th class="col-id">ID</th>
          <th class="col-message">Error Message</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="activeTab === 'validation'">
          <tr *ngIf="filteredValidationErrors.length === 0" class="validation-error-row-empty">
            <td [attr.colspan]="isQatarCluster ? 2 : 3" class="validation-error-row-empty-cell">
              No validation errors.
            </td>
          </tr>
          <tr *ngFor="let error of filteredValidationErrors; trackBy: trackByError" (click)="selectRow(error)"
            class="validation-error-row-clickable" [class.error-row--unenforced]="error.isUnenforced"
            [class.validation-error-row--selected]="isRowSelected(error)">
            <td class="col-id">{{ error.errorSequenceId }}</td>
            <td class="col-message">
              <ng-container *ngTemplateOutlet="msgBody5"></ng-container>

              <ng-template #msgBody5>
                <span class="validation-error-msg-flow">
                  <ng-container *ngTemplateOutlet="errorMessageCell; context: { error: error }"></ng-container>
                </span>
              </ng-template>
              <ng-container
                *ngTemplateOutlet="errorRowActions; context: { err: error }"></ng-container>



            </td>

          </tr>
        </ng-container>

        <ng-container *ngIf="activeTab === 'business'">
          <tr *ngIf="businessTableEmpty" class="validation-error-row-empty">
            <td [attr.colspan]="isQatarCluster ? 2 : 3" class="validation-error-row-empty-cell">
              No errors match the current filters.
            </td>
          </tr>

          <ng-container *ngIf="!businessTableEmpty && !isBusinessGroupedView">
            <tr *ngFor="let error of businessFlatDisplayErrors; trackBy: trackByError" (click)="selectRow(error)"
              class="validation-error-row-clickable" [class.error-row--unenforced]="error.isUnenforced"
              [class.validation-error-row--selected]="isRowSelected(error)">
              <td class="col-id">{{ error.errorSequenceId }}</td>
              <td class="col-message">

                <ng-container *ngTemplateOutlet="msgBody6"></ng-container>
                <ng-template #msgBody6>
                  <span class="validation-error-msg-flow">

                    <span class="validation-error-code-line" *ngIf="effectiveRuleIdForError(error) as rid">
                      <span *ngIf="errorCodeBadgeBucket(error) as bb" [ngClass]="badgeClassForBucket(bb)">{{
                        displayBadgeLabel(rid) }}</span>
                      <span *ngIf="errorCodeBadgeBucket(error) === null"
                        class="error-code-badge error-code-badge--plain">{{ displayBadgeLabel(rid) }}</span>
                      <span *ngFor="let cid of error.countryRuleIds || []"
                        class="error-code-badge error-code-badge--country">{{ displayBadgeLabel(cid) }}</span>
                      <ng-container *ngTemplateOutlet="validationNotesPill; context: { rid: rid }"></ng-container>
                    </span>
                    <ng-container *ngTemplateOutlet="errorMessageCell; context: { error: error }"></ng-container>
                  </span>
                </ng-template>
                <ng-container *ngTemplateOutlet="errorRowActions; context: { err: error }"></ng-container>





              </td>

            </tr>
          </ng-container>

          <ng-container *ngIf="!businessTableEmpty && isBusinessGroupedView">
            <ng-container *ngFor="let group of businessGroupedRows; trackBy: trackByBusinessGroup">
              <tr *ngIf="group.instances.length === 1" (click)="selectRow(group.instances[0])"
                class="validation-error-row-clickable" [class.error-row--unenforced]="group.instances[0].isUnenforced"
                [class.validation-error-row--selected]="isRowSelected(group.instances[0])">
                <td class="col-id">{{ group.instances[0].errorSequenceId }}</td>
                <td class="col-message">


                  <ng-container *ngTemplateOutlet="msgBody7"></ng-container>

                  <ng-template #msgBody7>
                    <span class="validation-error-msg-flow">

                      <span class="validation-error-code-line"
                        *ngIf="effectiveRuleIdForError(group.instances[0]) as rid">
                        <span *ngIf="errorCodeBadgeBucket(group.instances[0]) as bb"
                          [ngClass]="badgeClassForBucket(bb)">{{ displayBadgeLabel(rid) }}</span>
                        <span *ngIf="errorCodeBadgeBucket(group.instances[0]) === null"
                          class="error-code-badge error-code-badge--plain">{{ displayBadgeLabel(rid) }}</span>
                        <span *ngFor="let cid of group.instances[0].countryRuleIds || []"
                          class="error-code-badge error-code-badge--country">{{ displayBadgeLabel(cid) }}</span>
                        <ng-container *ngTemplateOutlet="validationNotesPill; context: { rid: rid }"></ng-container>
                      </span>
                      <ng-container
                        *ngTemplateOutlet="errorMessageCell; context: { error: group.instances[0] }"></ng-container>
                    </span>
                  </ng-template>
                  <ng-container *ngTemplateOutlet="errorRowActions; context: { err: group.instances[0] }"></ng-container>









                </td>


              </tr>

              <ng-container *ngIf="group.instances.length > 1">
                <tr class="validation-error-row-group-parent"
                  [class.error-row--unenforced]="group.instances[0].isUnenforced">
                  <td class="col-id">{{ group.groupIndex }}</td>
                  <td class="col-message">
                    <particle-dynamic-tooltip-container *ngIf="group.instances[0].tooltipMessage; else msgBody8"
                      [text]="group.instances[0].tooltipMessage || ''" [position]="'top'" [theme]="'dark'"
                      [cssClass]="'elite-form-validation-tooltip-content'" [width]="300">
                      <ng-container *ngTemplateOutlet="msgBody8"></ng-container>
                    </particle-dynamic-tooltip-container>
                    <ng-template #msgBody8>
                      <span class="validation-error-msg-flow">
                        <span [ngClass]="badgeClassForBucket(group.bucket)">{{ displayBadgeLabel(group.ruleId) }}</span>
                        <ng-container
                          *ngTemplateOutlet="validationNotesPill; context: { rid: group.ruleId }"></ng-container>
                        <span class="validation-error-group-summary">{{ group.summaryMessage }}</span>
                      </span>
                    </ng-template>
                  </td>
                </tr>
                <tr [class.error-row--unenforced]="group.instances[0].isUnenforced">
                  <td colspan="3" class="p-lr-0 p-tb-0">
                    <div class="validation-group-instance" (click)="toggleGroupExpanded(group, $event)">
                      <span class="validation-error-group-count">{{ group.instances.length }} instances</span>
                      <button type="button" class="validation-error-group-toggle"
                        [attr.aria-expanded]="isBusinessGroupExpanded(group.ruleId)">
                        <mat-icon>{{ isBusinessGroupExpanded(group.ruleId) ? 'expand_less' : 'expand_more' }}</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
                <ng-container *ngFor="let err of group.instances; let i = index">
                  <tr *ngIf="isBusinessGroupExpanded(group.ruleId)" (click)="selectRow(err)"
                    class="validation-error-row-clickable validation-error-row-group-child"
                    [class.error-row--unenforced]="err.isUnenforced"
                    [class.validation-error-row--selected]="isRowSelected(err)">
                    <td class="col-id">{{ group.groupIndex }}.{{ i + 1 }}</td>
                    <td class="col-message">
                      <ng-container *ngTemplateOutlet="msgBody9"></ng-container>
                      <ng-template #msgBody9>
                        <span class="validation-error-msg-flow">

                          <span class="validation-error-code-line" *ngIf="effectiveRuleIdForError(err) as rid">
                            <span *ngIf="errorCodeBadgeBucket(err) as bb" [ngClass]="badgeClassForBucket(bb)">{{
                              displayBadgeLabel(rid) }}</span>
                            <span *ngIf="errorCodeBadgeBucket(err) === null"
                              class="error-code-badge error-code-badge--plain">{{ displayBadgeLabel(rid) }}</span>
                            <span *ngFor="let cid of err.countryRuleIds || []"
                              class="error-code-badge error-code-badge--country">{{ displayBadgeLabel(cid) }}</span>
                            <ng-container *ngTemplateOutlet="validationNotesPill; context: { rid: rid }"></ng-container>
                          </span>
                          <ng-container *ngTemplateOutlet="errorMessageCell; context: { error: err }"></ng-container>
                        </span>
                      </ng-template>
                      <ng-container *ngTemplateOutlet="errorRowActions; context: { err: err }"></ng-container>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="validation-error-status validation-error-status--success" *ngIf="isAllChecksPassed">
    <div class="validation-error-status-icon-wrap">
      <!--      <mat-icon class="validation-error-status-icon">check_circle</mat-icon>-->
      <svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73" fill="none">
        <rect width="73" height="73" rx="10" fill="#3747D5" />
        <path
          d="M0 10C0 4.47715 4.47715 0 10 0H63C68.5228 0 73 4.47715 73 10V17C73 18.6569 71.6569 20 70 20H3C1.34315 20 0 18.6569 0 17V10Z"
          fill="#8FC9E9" />
        <path
          d="M37.443 24.0121C40.068 24.0055 42.6684 24.5188 45.094 25.5224C47.5195 26.526 49.7224 28 51.5753 29.8594C53.4282 31.7189 54.8945 33.9268 55.8896 36.3559C56.8847 38.785 57.3889 41.3872 57.373 44.0121C57.3969 46.6306 56.8909 49.2269 55.8856 51.6449C54.8803 54.0628 53.3963 56.2524 51.523 58.0821C49.6962 59.98 47.4977 61.4808 45.0648 62.4908C42.6319 63.5008 40.0168 63.9983 37.383 63.9521C34.6441 64.142 31.8954 63.7659 29.3082 62.8473C26.7209 61.9287 24.3505 60.4872 22.3446 58.6127C20.3387 56.7381 18.7401 54.4707 17.6486 51.9515C16.5571 49.4323 15.9959 46.7154 16 43.9699C16.0042 41.2244 16.5735 38.5092 17.6726 35.9933C18.7717 33.4775 20.377 31.2148 22.3886 29.3463C24.4002 27.4778 26.7749 26.0435 29.3649 25.1327C31.9549 24.2219 34.7047 23.854 37.443 24.0521V24.0121Z"
          fill="#8FC9E9" />
        <path
          d="M26.8525 46.4128L31.5725 41.6828L34.1225 44.2228L41.7525 36.6328L46.3025 41.1928C46.2972 41.3125 46.2636 41.4293 46.2045 41.5336C46.1454 41.6379 46.0625 41.7267 45.9625 41.7928C42.8225 44.9461 39.6792 48.0895 36.5325 51.2228C36.234 51.5585 35.8697 51.8293 35.4622 52.0185C35.0547 52.2076 34.6127 52.311 34.1635 52.3222C33.7144 52.3335 33.2678 52.2523 32.8513 52.0839C32.4349 51.9154 32.0575 51.6632 31.7425 51.3428C30.0525 49.7728 28.4625 48.0828 26.8425 46.4428C26.8325 46.3828 26.8325 46.3528 26.8525 46.4128Z"
          fill="#3747D5" />
      </svg>
    </div>
    <p class="validation-error-status-title">All checks passed</p>
    <p class="validation-error-status-sub">This form passed all validation rules and is ready to submit.</p>
  </div>

  <ng-template #errorMessageCell let-error="error">
    <ng-container
      *ngIf="(error.tooltipMessage || getTooltipText(error)) as tooltipText; else validationErrPlainTooltip">
      <!--      <particle-dynamic-tooltip-container [text]="tooltipText" [position]="'top'" [theme]="'dark'"-->
      <!--        [cssClass]="'elite-form-validation-tooltip-content'" [width]="300">-->
      <!--        <span class="validation-error-body-text">{{ displayErrorBodyText(error) }}</span>-->
      <!--      </particle-dynamic-tooltip-container>-->

      <span class="validation-error-body-text elite-form-validation-tooltip-content" [title]="tooltipText">{{
        displayErrorBodyText(error) }}</span>
    </ng-container>
    <ng-template #validationErrPlainTooltip>
      <span class="validation-error-body-text">{{ displayErrorBodyText(error) }}</span>
    </ng-template>
  </ng-template>

  <ng-template #errorRowActions let-err="err">
    <div class="col-xatbot" *ngIf="!isQatarCluster">
      <button type="button" class="validation-error-xatbot-btn" title="Ask XatBot about this error"
        (click)="openErrorInXatbot(err, $event)">
        <!-- GEN-E-52-11: ITP-2.0-only glowing mark; classic mode keeps its original static SVG below. -->
        <ai-tax-icon *ngIf="!platformToolLayoutService.isParticleAppLayout()" [size]="18" [idSuffix]="'validationerror-' + err.errorSequenceId" hoverHostSelector=".validation-error-xatbot-btn"></ai-tax-icon>
        <svg *ngIf="platformToolLayoutService.isParticleAppLayout()" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 17 17" fill="none">
          <path
            d="M10.8574 2.85547L12.75 2.125L13.4473 0.265625C13.4805 0.0996094 13.6465 0 13.8125 0C13.9453 0 14.1113 0.0996094 14.1445 0.265625L14.875 2.125L16.7344 2.85547C16.9004 2.88867 17 3.05469 17 3.1875C17 3.35352 16.9004 3.51953 16.7344 3.55273L14.875 4.25L14.1445 6.14258C14.1113 6.27539 13.9453 6.375 13.8125 6.375C13.6465 6.375 13.4805 6.27539 13.4473 6.14258L12.75 4.25L10.8574 3.55273C10.6914 3.51953 10.625 3.35352 10.625 3.1875C10.625 3.05469 10.6914 2.88867 10.8574 2.85547ZM8.5332 6.24219L12.3184 7.96875C12.5176 8.06836 12.6504 8.26758 12.6504 8.4668C12.6504 8.66602 12.5176 8.86523 12.3184 8.96484L8.5332 10.6914L6.80664 14.4766C6.70703 14.6758 6.50781 14.8086 6.30859 14.8086C6.10938 14.8086 5.91016 14.6758 5.84375 14.4766L4.08398 10.6914L0.298828 8.96484C0.0996094 8.86523 0 8.66602 0 8.4668C0 8.26758 0.0996094 8.06836 0.298828 7.96875L4.08398 6.24219L5.84375 2.45703C5.91016 2.25781 6.10938 2.125 6.30859 2.125C6.50781 2.125 6.70703 2.25781 6.80664 2.45703L8.5332 6.24219ZM13.4473 10.8906C13.4805 10.7246 13.6465 10.625 13.8125 10.625C13.9453 10.625 14.1113 10.7246 14.1445 10.8906L14.875 12.75L16.7344 13.4805C16.9004 13.5137 17 13.6797 17 13.8125C17 13.9785 16.9004 14.1445 16.7344 14.1777L14.875 14.875L14.1445 16.7676C14.1113 16.9004 13.9453 17 13.8125 17C13.6465 17 13.4805 16.9004 13.4473 16.7676L12.75 14.875L10.8574 14.1777C10.6914 14.1445 10.625 13.9785 10.625 13.8125C10.625 13.6797 10.6914 13.5137 10.8574 13.4805L12.75 12.75L13.4473 10.8906Z"
            fill="url(#validation-error-xatbot-sparkle)" />
        </svg>
        Ask XatBot
      </button>

      <button type="button" class="details-btn" *ngIf="hasValidationNote(err)" title="View priority details"
        (click)="openValidationDetailsDialog(err, $event)">
        Details
      </button>

      <button type="button" class="go-to-field-btn" *ngIf="!hideGotoField" [disabled]="!isGoToFieldAvailableInHost(err)"
        title="Go to Field"
        (click)="onClickGoToFieldButton(err); $event.stopPropagation()">
        Go to Field
      </button>
    </div>
    <!--<td *ngIf="!isQatarCluster">
      <i class="fa-sharp fa-regular fa-calculator-simple" (click)="resolveCalculationError(err)"></i>
    </td>-->
  </ng-template>

  <!-- Inline "priority details" indicator: a small coloured info icon shown
       next to the error-code badge whenever the rule carries an editorial note.
       Non-interactive — opening the detail is the "Details" action button. -->
  <ng-template #validationNotesPill let-rid="rid">
    <span *ngIf="getValidationNote(rid) as vn" class="priority-info-badge" [attr.data-category]="vn.category"
      (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()"
      aria-label="This error has priority details attached">
      <particle-dynamic-tooltip-container [text]="'This error has priority details attached.'" [position]="'bottom'"
        [theme]="'dark'" [cssClass]="'elite-form-validation-tooltip-content'" [width]="260">
        <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
      </particle-dynamic-tooltip-container>
    </span>
  </ng-template>
</ng-template>
